export function sumProperties(array, field) {
  // Return the sum of all values in `field` of an array of objects.
  // get sum of msgCount prop across all objects in array
  var sum = array.reduce(function(prev, cur) {
    return prev + cur[field];
  }, 0);
  return sum.toFixed(1)
}
